import LeadRepository from "./LeadsRepository";

const repositories = {
    leads: LeadRepository,
};

export const RepositoryFactory = {
    get: (name) => repositories[name],
};
